import React from 'react';

interface SkippedXml {
  filename: string;
  code?: string;
  message?: string;
}

interface Props {
  open: boolean;
  eligibleCount: number;
  skippedXmls: SkippedXml[];
  isSubmitting?: boolean;
  onProceed: () => void;
  onCancel: () => void;
}

const UploadAcknowledgementModal: React.FC<Props> = ({
  open,
  eligibleCount,
  skippedXmls,
  isSubmitting = false,
  onProceed,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-2xl rounded-lg bg-white p-6 shadow-xl">
        <h2 className="mb-2 text-lg font-semibold text-gray-900">Review XMLs</h2>
        <p className="mb-4 text-sm text-gray-600">
          <strong>{eligibleCount}</strong> game XMLs will be processed.
        </p>

        {skippedXmls.length > 0 && (
          <div className="mb-4 max-h-72 overflow-y-auto rounded border border-amber-200 bg-amber-50 p-3">
            <p className="mb-2 text-sm font-semibold text-amber-900">
              {skippedXmls.length} XML{skippedXmls.length === 1 ? '' : 's'} skipped
            </p>
            <ul className="space-y-2">
              {skippedXmls.map((item) => (
                <li
                  key={item.filename}
                  className="rounded bg-white px-3 py-2 text-sm text-gray-700 shadow-sm"
                >
                  <p className="font-medium">{item.filename}</p>
                  <p className="text-xs text-gray-500">{item.message || item.code}</p>
                </li>
              ))}
            </ul>
          </div>
        )}

        {skippedXmls.length === 0 && (
          <p className="mb-4 text-sm text-green-700">All XMLs are eligible for processing.</p>
        )}

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={isSubmitting}
            className="rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel & Re-upload
          </button>
          <button
            type="button"
            onClick={onProceed}
            disabled={isSubmitting}
            className="rounded-md bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-700 disabled:opacity-50"
          >
            {isSubmitting ? 'Starting…' : 'Proceed'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadAcknowledgementModal;
